(function () {
  var loaded = false;
  var events = ['pointerdown', 'touchstart', 'scroll', 'keydown'];

  function startWidget() {
    if (window.merchantwidget) {
      window.merchantwidget.start({ position: 'RIGHT_BOTTOM' });
    }
  }

  function removeTriggers() {
    events.forEach(function (eventName) {
      window.removeEventListener(eventName, loadWidget);
    });
  }

  function loadWidget() {
    if (loaded) return;
    loaded = true;
    removeTriggers();

    var existing = document.getElementById('merchantWidgetScript');
    if (existing) {
      startWidget();
      return;
    }

    var script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.async = true;
    script.addEventListener('load', startWidget, { once: true });
    document.head.appendChild(script);
  }

  function scheduleWidget() {
    events.forEach(function (eventName) {
      window.addEventListener(eventName, loadWidget, { passive: true });
    });
  }

  if (document.readyState === 'complete') {
    scheduleWidget();
  } else {
    window.addEventListener('load', scheduleWidget, { once: true });
  }
})();